import { render, staticRenderFns } from "./SettingCard.vue?vue&type=template&id=2007cc53&scoped=true&"
import script from "./SettingCard.vue?vue&type=script&lang=js&"
export * from "./SettingCard.vue?vue&type=script&lang=js&"
import style0 from "./SettingCard.vue?vue&type=style&index=0&id=2007cc53&lang=scss&scoped=true&"
import style1 from "./SettingCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007cc53",
  null
  
)

export default component.exports